import React from 'react';
import Link, { LinkProps } from 'next/link';
import { ButtonVisualProps } from './types';
import { getButtonClasses, ButtonContent } from './utils';

type ButtonLinkProps = ButtonVisualProps &
  LinkProps & {
    target?: React.HTMLAttributeAnchorTarget;
    rel?: string;
  };

const ButtonLink = ({
  children,
  variant,
  size = 'medium',
  isFullWidth,
  isLoading,
  StartIcon,
  EndIcon,
  className,
  disabled,
  onClick,
  ...props
}: ButtonLinkProps) => {
  const shouldBlockInteraction = disabled || isLoading;

  const classes = getButtonClasses({
    variant,
    size,
    isFullWidth,
    isLoading,
    StartIcon,
    EndIcon,
    disabled,
    className,
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (shouldBlockInteraction) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <Link className={classes} aria-disabled={shouldBlockInteraction} onClick={handleClick} {...props}>
      <ButtonContent isLoading={isLoading} size={size} StartIcon={StartIcon} EndIcon={EndIcon}>
        {children}
      </ButtonContent>
    </Link>
  );
};

export { ButtonLink, type ButtonLinkProps };
